import { Component, default as React } from "react";
import { Link } from "react-router-dom";
import TimeUtils from "../utils/TimeUtils";
import { formatNumber } from "../utils/NumberUtils";

interface TopFiveProps {
	title: string;
	icon: string;
	leaderboard: any[];
	isTime: boolean;
	gradient: string;
	link: string;
}

class MainTopFive extends Component<TopFiveProps, any> {

	public render() {
		return (
			<div className="col-md-6 col-xl-4">
				<div className="block block-rounded">
					<div className={"block-content block-content-full text-center " + this.props.gradient}>
						<div className="item item-circle mx-auto bg-black-25">
							<i className={'fas fa-2x text-white fa ' + this.props.icon}/>
						</div>
						<p className="text-white font-size-h3 font-w300 mt-3 mb-0">
							{this.props.title}
						</p>
						<p className="text-white-75 mb-0">
							Top 5
						</p>
					</div>
					<div className="block-content block-content-full">
						<table className="table table-borderless table-striped table-hover">
							<tbody>
							{this.generateTable()}
							</tbody>
						</table>
						<div className="text-center">
							<Link className="btn btn-primary" to={this.props.link}>
								Zobrazit vše...
							</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}

	public generateTable() {
		if (this.props.leaderboard == null) {
			return null;
		}
		let finalTable: any = [];
		for (let i = 0; i < this.props.leaderboard.length; i++) {
			let player = this.props.leaderboard[i];
			if (i >= 5) {
				break;
			}
			if (player.hasOwnProperty("level")) {
				// @ts-ignore
				finalTable.push(
					<tr key={player.index}>
						<td className="text-center">{player.index}.</td>
						<td>
							<strong>{player.nick}</strong>
						</td>
						<td className="text-center" style={{width: '40px'}}>
							<strong className="text-success">{formatNumber(player.level)}</strong>
						</td>
					</tr>
				);
			} else {
				// @ts-ignore
				finalTable.push(
					<tr key={player.index}>
						<td className="text-center">{player.index}.</td>
						<td>
							<strong>{player.nick}</strong>
						</td>
						<td className="text-center" style={this.props.isTime ? {width: '95px'} : {width: '40px'}}>
							<strong
								className="text-success">{this.props.isTime ? TimeUtils.convertTime(player.value) : formatNumber(player.value)}</strong>
						</td>
					</tr>
				);
			}
		}
		return finalTable;
	}

}

export default MainTopFive;
